import { ISettingsStore } from './settings-store';

export abstract class SettingsStoreFactory {
  abstract get(): ISettingsStore;
}
